import React from 'react';
import App from './App';
import DevopsPage from './DevopsPage';

export function pageKindFromPath(pathname) {
    const p = String(pathname || '/').replace(/\/+$/, '') || '/';
    if (p === '/devops') {
        return 'devops';
    }
    return 'home';
}

const Root = ({ page }) => {
    if (page === 'devops') {
        return <DevopsPage />;
    }
    return <App />;
};

export default Root;
